import React from "react";
import { Control, DeepMap, FieldError } from "react-hook-form";
import { Form } from "semantic-ui-react";
import {
  ControlledInput,
  IStrictControlledInputProps,
  ControlledTextArea,
  IStrictControlledTextAreaProps,
} from "../../../../../../components/ControlledForm";
import { ControlledPhoneNumber } from "../../../../../../components/global_components/form_components/ControlledPhoneNumber";
import useInspection from "../../../../hooks/inspections/useInspection";

interface IOnSiteContactInfoFields {
  id?: string | number;
  control: Control<{
    onSiteContactInstructions: string;
    onSiteContactName: string;
    onSiteContactPhone: string;
    onSiteContactApplicantInstructions: string;
  }>;
  errors: DeepMap<
    {
      onSiteContactInstructions: string;
      onSiteContactName: string;
      onSiteContactPhone: string;
      onSiteContactApplicantInstructions: string;
    },
    FieldError
  >;
}

export default function OnSiteContactInfoFields({ id, control, errors }: IOnSiteContactInfoFields) {
  const { inspectionQuery } = useInspection({ id: String(id), enabled: !!id });
  const onSiteContactApplicantInstructions = inspectionQuery.data?.data.attributes.onSiteContactApplicantInstructions;

  return (
    <div>
      <Form.Group>
        <Form.Field required width={8} error={!!errors.onSiteContactName}>
          <ControlledInput<IStrictControlledInputProps<"onSiteContactName", string>>
            control={control}
            name={"onSiteContactName"}
            label='Onsite Contact Name'
            required
            rules={{
              validate: {
                _length: (value) => {
                  if (typeof value !== "string") {
                    return false;
                  }
                  const MAX_LENGTH = 191;
                  if (value.length > MAX_LENGTH) {
                    return `Name cannot be greater than ${MAX_LENGTH} characters`;
                  }
                  if (value.length <= 0) {
                    return `Name cannot be blank`;
                  }
                  return true;
                },
              },
            }}
            errors={errors}
          />
        </Form.Field>
        <Form.Field width={8} error={!!errors.onSiteContactPhone}>
          <ControlledPhoneNumber
            control={control}
            name={"onSiteContactPhone"}
            label='Onsite Contact Phone'
            readonly={false}
            errors={errors}
          />
        </Form.Field>
      </Form.Group>
      <Form.Field error={!!errors.onSiteContactInstructions}>
        <label>
          Instructions for the Inspectors
          {onSiteContactApplicantInstructions && (
            <div className='subText tw-py-0.5 tw-text-sm'>From Applicant: {onSiteContactApplicantInstructions}</div>
          )}
        </label>
        <ControlledTextArea<IStrictControlledTextAreaProps>
          control={control}
          name={"onSiteContactInstructions"}
          rows={2}
          rules={{
            validate: {
              _length: (value) => {
                if (typeof value !== "string") {
                  return false;
                }
                const MAX_LENGTH = 191;
                if (value.length > MAX_LENGTH) {
                  return `Instructions cannot be greater than ${MAX_LENGTH} characters`;
                }
                return true;
              },
            },
          }}
          errors={errors}
        />
      </Form.Field>
    </div>
  );
}
